import React, { useEffect } from "react";
import TokenContext from "components/TokenContext";
import { auth } from "../../_services/authService";
import { Translation, withTranslation } from "react-i18next";
import Background from "../../assets/img/register_bg_2.png";
import Navbar from "components/Navbars/AuthNavbar.js";
import FooterSmall from "components/Footers/FooterSmall.js";
import { Alert,
  Box, 
  Container, 
  Paper, 
  TextField, 
  Button, 
  Typography, 
  Divider, CardContent
} from "@mui/material";
import { InputAdornment, IconButton } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

function Login(props) {
  const [denied, setDenied] = React.useState(true);
  const [loginError, setLoginError] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [wronguser, setWronguser] = React.useState(false); //inserito wrong username nella password dimenticata
  const [wrongcode, setWrongcode] = React.useState(false); //inserito wrong code
  const [forgot, setForgot] = React.useState(false); //setta la visione della page di pwd dimenticata
  const [showcode, setShowcode] = React.useState(false); //mostra text per inserimento code
  const [controlcode, setControlcode] = React.useState("");
  const useCounterContext = () => React.useContext(TokenContext);
  const [isHq, setIsHq] = React.useState(false);
  let { assignJwt } = useCounterContext();

  useEffect(() => {
    fetchData();
    localStorage.setItem("isHq", props.isHq ? "true" : "false");
    setIsHq(props.isHq)
  }, []);

  async function fetchData() {
    const at = await auth.AuthCheckAccessToken();
    if (at != null) {
      setDenied(false);
      assignJwt(at);
      props.history.push("/app/home");
    }
  }

  async function handleSubmit() {
    try {
      auth
        .AuthLogin(username, password)
        .then((response) => {
          assignJwt(response);
          //console.log("After Login",jwt);
          setDenied(false);
          setLoginError(false);
          props.history.push("/app/home");
        })
        .catch(() => {
          setDenied(true);
          setLoginError(true);
        });
    } catch (e) {
      setDenied(true);
      setLoginError(true);
    }
  }

  async function handleGetCode() {
    try {
      auth
        .AuthSendResetCode(username)
        .then((response) => {
          setShowcode(true);
          setWronguser(false);
        })
        .catch(() => {
          setWronguser(true);
          setShowcode(false);
        });
    } catch (e) {
      setWronguser(true);
      setShowcode(false);
    }
  }

  async function handleSendCode() {
    try {
      auth
        .AuthResetPasswordByCode(username, controlcode)
        .then((response) => {
          //console.log("codice spedito");
          setForgot(false);
          setShowcode(false);
          setPassword("");
          //props.history.push("/auth/login");
          //props.history.push("/");
        })
        .catch(() => {
          setWrongcode(true);
        });
    } catch (e) {
      setWrongcode(true);
    }
  }

  async function handleKeyPress(event) {
    if (event.key === "Enter") {
      handleSubmit();
    }
  }

  const loginChanged = (e) => {
    //console.log(e.target.value);
    setUsername(e.target.value);
    if (loginError) setLoginError(false);
  };

  const passwordChanged = (e) => {
    setPassword(e.target.value);
    if (loginError) setLoginError(false);
  };

  const handleChange = (event) => {
    setUsername(event.target.value);
    setDenied(false);
  };
  const handleChangeCode = (event) => {
    setControlcode(event.target.value);
  };

  return (
    <Translation>
      {(t, { i18n }) => (
        <main>
          <Navbar transparent setForgot={setForgot}/>
          <Box component="section" sx={{ position: "relative", width: "100%", height: "100%", py: 5, minHeight: "100vh" }}>
            <Box
              sx={{
                position: "absolute",
                top: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "#1a202c", // Corrisponde a bg-gray-900
                backgroundImage: `url(${Background})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover", // Sostituisce bg-full per una migliore resa
                backgroundPosition: "center"
              }}
            />
              <Container maxWidth="lg" sx={{ height: "100%" }}>
                <Box
                  sx={{
                    display: "flex",
                    alignContent: "center",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    pt: 10
                  }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      px: 2, // Corrisponde a px-4 di Tailwind (16px)
                      flex: {
                        xs: "0 0 100%",    // Mobile: tutto schermo
                        sm: "0 0 70%",    // Tablet small
                        md: "0 0 50%",    // Tablet/Laptop: 60% della larghezza
                        lg: "0 0 42%",    // Desktop standard: 45% (molto più leggibile)
                        xl: "0 0 42%"     // Schermi giganti: torniamo più stretti
                      },
                      maxWidth: {
                        xs: "100%",
                        sm: "70%",
                        md: "50%",
                        lg: "42%",
                        xl: "42%"
                      },
                      transition: "all 0.3s ease-in-out" // Rende il cambio fluidissimo
                    }}
                  >
                    <Paper
                        elevation={3}
                        sx={{
                          position: "relative",
                          display: "flex",
                          flexDirection: "column",
                          minWidth: 0,
                          wordWrap: "break-word",
                          width: "100%",
                          mb: 3, // Corrisponde a mb-6 (24px)
                          borderRadius: "0.5rem", // Corrisponde a rounded-lg
                          backgroundColor: "#e2e8f0", // Corrisponde a bg-gray-300
                          border: 0
                        }}
                      >
                     <Box
                          sx={{
                            borderRadius: "0.5rem 0.5rem 0 0", // Corrisponde a rounded-t
                            mb: 0,
                            px: 3, // Corrisponde a px-6 (24px)
                            py: 3  // Corrisponde a py-6 (24px)
                          }}
                        >
                       <Box
                          sx={{
                            width: "100%", // Aggiungi questo per forzare la larghezza
                            textAlign: "center",
                            mb: 1.5
                          }}
                        >
                          <Typography
                              variant="subtitle2"
                              sx={{
                                display: "inline-block",
                                color: "#718096", // Corrisponde a text-gray-600
                                fontWeight: 700,  // Corrisponde a font-bold
                                fontSize: "0.875rem", // Corrisponde a text-sm
                                textTransform: "uppercase", // Di solito le h6 in questo template sono uppercase
                              }}
                            >
                            VoluntHUB {isHq ? "HQ" : ""} | {t("Login")}
                          </Typography>
                        </Box>
                        <Divider 
                            sx={{ 
                              mt: 3, // Corrisponde a mt-6 (24px)
                              mb: 0, 
                              borderColor: "#cbd5e0", // Corrisponde a border-gray-400
                              borderBottomWidth: 1 
                            }} 
                          />
                      </Box>
                      {!forgot && (
                        <CardContent sx={{ px: { xs: 4, lg: 10 }, py: 5, pt: 0 }}>
                          {/* Messaggio: Immettere le proprie credenziali */}
                          <Typography
                            variant="body2"
                            sx={{
                              textAlign: "center",
                              mb: 3,
                              fontWeight: "bold",
                              color: "text.secondary"
                            }}
                          >
                            {t("credentials")}
                          </Typography>

                          <form>
                            {/* Campo Email */}
                            <TextField
                              fullWidth
                              label={t("email").toUpperCase()}
                              variant="outlined"
                              margin="normal"
                              value={username}
                              onChange={loginChanged}
                              onKeyUp={handleKeyPress}
                              placeholder={t("email")}
                              sx={{
                                mb: 3,
                                backgroundColor: "white",
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: "0.25rem",
                                  boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)"
                                }
                              }}
                              error={loginError}
                            />

                            {/* Campo Password */}
                            <TextField
                                fullWidth
                                label={t("password").toUpperCase()}
                                type={showPassword ? "text" : "password"}
                                variant="outlined"
                                margin="normal"
                                value={password}
                                onChange={passwordChanged}
                                onKeyUp={handleKeyPress}
                                placeholder={t("password")}
                                error={loginError}
                                // SOSTITUISCI slotProps con InputProps
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        aria-label={showPassword ? t("hidePassword") : t("showPassword")}
                                        onClick={() => setShowPassword((v) => !v)}
                                        edge="end"
                                        tabIndex={-1}
                                      >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              />

                            {/* Bottone Login */}
                            <Box sx={{ textAlign: "center", mt: 6 }}>
                              <Button
                                fullWidth
                                variant="contained"
                                onClick={handleSubmit}
                                sx={{
                                  bgcolor: "#1a202c", // gray-900
                                  color: "white",
                                  fontWeight: "bold",
                                  py: 1.5,
                                  textTransform: "uppercase",
                                  borderRadius: "0.25rem",
                                  "&:hover": {
                                    bgcolor: "#2d3748", // gray-700
                                    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)"
                                  },
                                  transition: "all 0.15s ease-linear"
                                }}
                              >
                                {t("Login")}
                              </Button>
                            </Box>
                          </form>
                          {loginError && (
                            <Alert
                              severity="error"
                              onClose={() => setLoginError(false)}
                              sx={{ mb: 3, borderRadius: "0.25rem" }}
                            >
                              {t("Autenticazione Fallita") /* es. "Credenziali non valide o errore di connessione. Riprova." */}
                            </Alert>
                          )}
                        </CardContent>
                      )}
                      {forgot && (
                        <CardContent sx={{ px: { xs: 4, lg: 10 }, py: 5, pt: 0 }}>
                          <form>
                            {/* Sezione Email - Sempre visibile in questo ramo */}
                            <Box sx={{ mb: 3 }}>
                              <Typography
                                variant="caption"
                                display="block"
                                sx={{ fontWeight: "bold", textTransform: "uppercase", mb: 1, color: "#4a5568" }}
                              >
                                {t("introForgotPwd")}
                              </Typography>
                              <TextField
                                fullWidth
                                type="email"
                                variant="outlined"
                                value={username}
                                onChange={handleChange} // La tua funzione originale
                                placeholder={t("email")}
                                sx={{
                                  backgroundColor: "white",
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: "0.25rem",
                                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                                  }
                                }}
                              />
                            </Box>

                            {/* Primo Bottone: handleGetCode */}
                            <Box sx={{ textAlign: "center", mt: 4 }}>
                              <Button
                                fullWidth
                                variant="contained"
                                onClick={handleGetCode} // La tua funzione originale
                                sx={{
                                  bgcolor: "#1a202c",
                                  color: "white",
                                  fontWeight: "bold",
                                  py: 1.5,
                                  textTransform: "uppercase",
                                  borderRadius: "0.25rem",
                                  "&:hover": { bgcolor: "#2d3748" }
                                }}
                              >
                                {t("sendCode")}
                              </Button>
                            </Box>

                            {/* Sezione Codice - Appare solo se showcode è true */}
                            {showcode && (
                              <Box sx={{ mt: 4 }}>
                                <Typography
                                  variant="caption"
                                  display="block"
                                  sx={{ fontWeight: "bold", textTransform: "uppercase", mb: 1, color: "#4a5568" }}
                                >
                                  {t("pleaseconfirmCode")}
                                </Typography>
                                <TextField
                                  fullWidth
                                  variant="outlined"
                                  value={controlcode}
                                  onChange={handleChangeCode} // La tua funzione originale
                                  placeholder={t("controlCode")}
                                  sx={{
                                    mb: 2,
                                    backgroundColor: "white",
                                    "& .MuiOutlinedInput-root": {
                                      borderRadius: "0.25rem",
                                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                                    }
                                  }}
                                />
                                <Button
                                  fullWidth
                                  variant="contained"
                                  onClick={handleSendCode} // La tua funzione originale
                                  sx={{
                                    bgcolor: "#1a202c",
                                    color: "white",
                                    fontWeight: "bold",
                                    py: 1.5,
                                    textTransform: "uppercase",
                                    borderRadius: "0.25rem",
                                    "&:hover": { bgcolor: "#2d3748" }
                                  }}
                                >
                                  {t("confirmCode")}
                                </Button>
                              </Box>
                            )}

                            {/* Messaggi di Errore - Mantengono la tua struttura condizionale */}
                            {wronguser && (
                              <Typography 
                                variant="body2" 
                                sx={{ mt: 2, color: "#e53e3e", fontWeight: "bold", textAlign: "center" }}
                              >
                                &nbsp;{t("wrongUser")}.
                              </Typography>
                            )}
                            
                            {wrongcode && (
                              <Typography 
                                variant="body2" 
                                sx={{ mt: 2, color: "#e53e3e", fontWeight: "bold", textAlign: "center" }}
                              >
                                &nbsp;{t("wrongCode")}.
                              </Typography>
                            )}
                          </form>
                        </CardContent>
                      )}
                    </Paper>
                    <Box sx={{ display: "flex", flexWrap: "wrap", mt: 6, position: "relative" }}>
                      {!forgot && (
                        <Button
                          fullWidth
                          variant="text" // Usiamo 'text' per renderlo meno pesante visivamente
                          onClick={() => setForgot(true)}
                          sx={{
                            color: "white",
                            fontWeight: "bold",
                            textTransform: "uppercase",
                            fontSize: "0.75rem",
                            "&:hover": { backgroundColor: "transparent", textDecoration: "underline" }
                          }}
                        >
                          {t("forgotPassword")}?
                        </Button>
                      )}
                    </Box>
                  </Box>
                </Box>
              </Container>
            
            <FooterSmall absolute />
          </Box>
        </main>
      )}
    </Translation>
  );
}
export default withTranslation()(Login);
